import React, { useState, useEffect, Fragment, useCallback } from 'react';

export default function StepTwo ({ quoteDetails, marqueeInfo, setQuoteDetails, setStepState, handleStartAgain }) {
	const [heading, setHeading] = useState(null);
	const [description, setDescription] = useState(null);
	const [abacus, setAbacus] = useState(false);

	useEffect(() => {
		getRecommendedMarquee();
	}, [getRecommendedMarquee]);

	const getRecommendedMarquee = useCallback(() => {
		const { partyGuests, partyStandSeat } = quoteDetails;
		const marqueeList = marqueeInfo.marquee_list;

		let foundMarquee;

		marqueeList.find((marquee) => {
			if (parseInt(partyGuests) <= parseInt(marquee[partyStandSeat])) {
				setQuoteDetails({
					marquee: {
						size: marquee['marquee_name'],
						value: marquee['marquee_value'],
						index: marqueeList.indexOf(marquee),
						options: marquee['marquee_options']
					},
					recommendedMarquee: marquee['marquee_name'],
					recommendedMarqueeIndex: marqueeList.indexOf(marquee)
				});

				foundMarquee = true;
			} else if (parseInt(partyGuests) > parseInt(marqueeList[marqueeList.length - 1][partyStandSeat])) {
				setHeading('Unfortunately we cannot cover your party size, but maybe our sister company can! we will redirect you!');
				setDescription('');
				setAbacus(true);

				setTimeout(() => {
					window.location.href = "http://www.abacusmarqueehire.co.uk/";
				}, 2500);

				foundMarquee = true;
			}

			return foundMarquee;
		});
	}, [marqueeInfo, quoteDetails, setQuoteDetails]);

	const updateMarqueeSelected = useCallback((e) => {
		e.preventDefault();
		e.stopPropagation();

		if (quoteDetails.marquee.size === e.currentTarget.parentNode.parentNode.dataset.marquee) {
			addMarqueeToQuote(e.currentTarget.parentNode.parentNode.dataset);
		} else {
			addMarqueeToQuote(e.currentTarget.parentNode.parentNode.dataset);
		}
	}, [addMarqueeToQuote, quoteDetails]);

	const addMarqueeToQuote = useCallback((marqueeData) => {
		const marquee = marqueeData.marquee;
		const value = marqueeData.value;
		const options = marqueeData.options;
		const prevSelection = quoteDetails.marquee;

		if (prevSelection.size !== marquee) {
			setQuoteDetails({
				marquee: {
					size: marquee,
					value: value,
					index: parseInt(marqueeData.index),
					options: JSON.parse(options)
				}
			});
			updateMarqueeStates(marquee, prevSelection);
		}
	}, [quoteDetails, setQuoteDetails]);

	const updateMarqueeStates = (marquee, prevSelection) => {
		if (document.querySelector(`[data-marquee="${marquee}"]`).dataset.marqueeSelected) {
			if (prevSelection && marquee !== Object.keys(prevSelection)[0]) {
				document.querySelector(`[data-marquee="${marquee}"]`).dataset.marqueeSelected = 'true';
				document.querySelector(`[data-marquee="${prevSelection.size}"]`).dataset.marqueeSelected = 'false';
			}
		}
	};

	const replacePlaceholdersWithValues = useCallback(() => {
		const marqueeHeading = marqueeInfo.heading;
		let marqueeDescription = marqueeInfo.description ? marqueeInfo.description : null;

		marqueeDescription = marqueeDescription.replace('<guests>', quoteDetails.partyGuests);
		marqueeDescription = marqueeDescription.replace('<seatstand>', quoteDetails.partyStandSeat);

		setHeading(marqueeHeading.replace('<size>', quoteDetails.recommendedMarquee));
		setDescription(marqueeDescription);
	}, [marqueeInfo, quoteDetails]);

	const renderMarquees = useCallback(() => {
		const marquees = [];

		marqueeInfo.marquee_list.forEach((marquee, index, arr) => {
			const { marquee_name, marquee_value, marquee_options, marquee_image } = marquee;
			const handleClick = updateMarqueeSelected;
			const marqueeIndex = marqueeInfo.marquee_list.indexOf(marquee);
			let selected = false;

			if (quoteDetails.marquee.index === marqueeIndex) {
				selected = true;
			}

			marquees.push(
				<div
					key={marqueeIndex}
					className="marquee-list__card"
					data-index={marqueeIndex}
					data-marquee-selected={selected ? true : false}
					data-marquee={marquee_name}
					data-value={marquee_value}
					data-options={JSON.stringify(marquee_options)}
				>
					<div className="marquee-list__card-left">
						<img src={marquee_image} alt="" />
					</div>
					<div className="marquee-list__card-right">
						<h4>{marquee_name} Meters</h4>
						<p>Holds {marquee.standing} Standing</p>
						<p>Holds {marquee.seated} Seated</p>
						<button onClick={handleClick}>{selected ? 'selected' : 'select'}</button>
					</div>
				</div>
			);

			if (arr.length - 1 === index) {
				scrollIntoView();
			}
		});

		return marquees;
	}, [marqueeInfo, quoteDetails, updateMarqueeSelected]);

	const scrollIntoView = () => {
		setTimeout(() => {
			document.querySelector('[data-marquee-selected="true"]').scrollIntoView({ behavior: "smooth", block: "center" });
		}, 100);
	};

	const handleNextClick = useCallback(() => {
		setTimeout(() => {
			setStepState(3);
		}, 800);
	}, [setStepState]);

	const renderStepTwoMarkup = useCallback(() => {

		return quoteDetails.recommendedMarquee ? (
			<div className="step-two__section">
				{abacus ? (
					<Fragment>
						<h4>{heading}</h4>
						<div className="loader">
							<div className="loader-inner"></div>
							<div className="loader-triangle"></div>
						</div>
					</Fragment>
				) : (
					<Fragment>
						<div className="step-two__info-container">
							<h4>{heading}</h4>
							<p>{description}</p>
						</div>

						<div className="step-two__marquee-list">
							<p>{marqueeInfo.marquee_list_information}</p>
							{renderMarquees()}
						</div>

						<button onClick={handleNextClick} className="step-two__next-btn">
							Choose your options
						</button>
						<button onClick={handleStartAgain} className="quote-calculator__back-btn">
							Start Again
						</button>
					</Fragment>
				)}
			</div>
		) : null;
	}, [abacus, description, handleNextClick, handleStartAgain, heading, marqueeInfo, quoteDetails, renderMarquees]);

	useEffect(() => {
		if (quoteDetails.recommendedMarquee) {
			replacePlaceholdersWithValues();
		}
	}, [quoteDetails.recommendedMarquee, replacePlaceholdersWithValues]);

	return <div className="step-two">{heading ? renderStepTwoMarkup() : <div className="loader"><div className="loader-inner"></div><div className="loader-triangle"></div></div>}</div>;
}
